import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './stockStatusActionTypes';
import * as actions from './stockStatusActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

// Get Stock Status
function* getStockStatusSaga(action) {
  try {

    const userData = JSON.parse(localStorage.getItem('user'));
    const sessionUserId = localStorage.getItem('sessionUserId');
    const userId = sessionUserId || userData?.sessionUserId || userData?.user?.sessionUserId;

    const payload = {
      SessionUserId: String(userId),
    };

    const { data } = yield call(endpoints.getStockStatus, payload);
    yield put(actions.getStockStatusDataAction(data));
  } catch (e) {
    yield put(actions.getStockStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

// Create Stock Status
function* createStockStatusSaga(action) {
  try {
    console.log('createStockStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create stock status API payload:', payload);
    
    const { data } = yield call(endpoints.createStockStatus, payload);
    console.log('Create stock status API response:', data);
    
    yield put(actions.createStockStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/stock-status');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createStockStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createStockStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

// Update Stock Status
function* updateStockStatusSaga(action) {
  try {
    console.log('updateStockStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update stock status API payload:', payload);
    
    const { data } = yield call(endpoints.updateStockStatus, payload);
    console.log('Update stock status API response:', data);
    
    yield put(actions.updateStockStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getStockStatusRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/stock-status');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateStockStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateStockStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

// Delete Stock Status
function* deleteStockStatusSaga(action) {
  try {
    console.log('deleteStockStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete stock status API payload:', payload);
    
    const { data } = yield call(endpoints.deleteStockStatus, payload);
    console.log('Delete stock status API response:', data);
    
    yield put(actions.deleteStockStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getStockStatusRequestAction());
    }
    
  } catch (e) {
    console.error('deleteStockStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteStockStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

// Watcher Sagas
function* watchGetStockStatus() {
  yield takeEvery(types.GET_STOCK_STATUS_REQUEST, getStockStatusSaga);
}

function* watchCreateStockStatus() {
  yield takeEvery(types.CREATE_STOCK_STATUS_REQUEST, createStockStatusSaga);
}

function* watchUpdateStockStatus() {
  yield takeEvery(types.UPDATE_STOCK_STATUS_REQUEST, updateStockStatusSaga);
}

function* watchDeleteStockStatus() {
  yield takeEvery(types.DELETE_STOCK_STATUS_REQUEST, deleteStockStatusSaga);
}

export function* stockStatusSaga() {
  yield all([
    watchGetStockStatus(),
    watchCreateStockStatus(),
    watchUpdateStockStatus(),
    watchDeleteStockStatus(),
  ]);
}
